import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router-dom";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import { useContext } from "react";
import Loader from "../components/common/Loader";
import { ChangePwdForm } from "../components/forms/ChangePwdForm";
import AuthContainer from "../components/AuthContainer";
import { clearAllBodyScrollLocks } from "body-scroll-lock";

interface IParams {
  tenant: string;
}

const AuthLayout: React.FC<RouteComponentProps<IParams>> = ({
  history,
  location,
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    getCompany,
    loadingCompany,
    isNativeApp,
    isOnline,
    isOfflineModeEnabled,
  } = rootStore.commonStore;
  const { isLoggedIn } = rootStore.userStore;
  const [pwdChangeToken, setPwdChangeToken] = useState("");
  const [pwdChangeUserId, setPwdChangeUserId] = useState("");
  const {setAuthenticatorAppResetToken}= rootStore.userStore;
  const handleResize = () => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
  };

  useEffect(() => {
    clearAllBodyScrollLocks();
    if (isNativeApp && (!isOnline || isOfflineModeEnabled))
      history.push("/offline");
    else {
      let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
      window.addEventListener("resize", handleResize);
      //connesso alla rete
      // document.body.classList.remove("pt-0");
      document.body.classList.add("form-membership");
      // document.body.classList.add("pt-0");
      document.body.style.paddingTop = `${responsivePaddingTop}px`;
      if (isLoggedIn) {
        let nextUrl = "/home";
        if (match.params.tenant)
          nextUrl = "/" + match.params.tenant + "/meetings";
        history.push(nextUrl);
      }

      const urlParams = new URLSearchParams(location.search);
      const pwdToken = urlParams.get("token") ?? "";
      const userId = urlParams.get("uid") ?? "";
      if (pwdToken && userId) {
        //logica gestione link recupero psw
        setPwdChangeToken(pwdToken);
        setPwdChangeUserId(userId);
      }
      const authenticator=urlParams.get("authenticatortoken") ?? "";
      if(authenticator){
        setAuthenticatorAppResetToken(authenticator);
      }
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [
    getCompany,
    isLoggedIn,
    history,
    location.search,
    match.params.tenant,
    isNativeApp,
    isOnline,
    isOfflineModeEnabled,
  ]);

  if (loadingCompany) return <Loader />;

  return (
    <Container>
      <Row>
        <Col />
        <Col lg="8">
          {/* <Jumbotron>
            <h3>Benvenuto in {company && company.displayName}</h3>
            <hr />
            <Card>
              <CardBody> */}
          {/* <LoginForm /> */}
          <Row className="justify-content-center">
            {pwdChangeToken ? (
              <ChangePwdForm
                userId={pwdChangeUserId}
                token={pwdChangeToken}
                onSuccess={() => {
                  setPwdChangeToken("");
                  setPwdChangeUserId("");
                }}
              />
            ) : (
              <AuthContainer />
            )}
          </Row>
          {/* </CardBody>
            </Card>
          </Jumbotron> */}
        </Col>
        <Col />
      </Row>
    </Container>
  );
};

export default observer(AuthLayout);
